import React, { useState } from "react";
import { Bell, X } from "lucide-react";
import usePush from "../lib/usePush";

const DISMISS_KEY = "pp_push_prompt_dismissed";

export default function NotificationPrompt() {
  const { supported, subscribed, busy, enable } = usePush();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === "1"; } catch { return false; }
  });

  const permissionDenied =
    typeof window !== "undefined" && "Notification" in window && Notification.permission === "denied";

  if (!supported || subscribed || dismissed || permissionDenied) return null;

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch { /* ignore */ }
    setDismissed(true);
  };

  const turnOn = async () => {
    const ok = await enable();
    if (ok) dismiss();
  };

  return (
    <div className="relative rounded-2xl border border-[#3D5844]/30 bg-[#3D5844]/5 p-5 flex items-start gap-4 fade-up" data-testid="push-prompt">
      <div className="w-11 h-11 rounded-full bg-[#3D5844]/10 flex items-center justify-center shrink-0">
        <Bell className="w-5 h-5 text-[#3D5844]" />
      </div>
      <div className="flex-1 pr-6">
        <p className="font-medium text-[#2A2621]">Never miss a word of encouragement</p>
        <p className="text-sm text-[#615A50] mt-1">Turn on notifications to be gently reminded when a new devotional, teaching, or daily encouragement is posted.</p>
        <button onClick={turnOn} disabled={busy} data-testid="push-prompt-enable"
          className="mt-3 rounded-full bg-[#3D5844] text-white px-5 py-2.5 text-sm font-medium hover:bg-[#2F4535] disabled:opacity-60">
          {busy ? "Turning on…" : "Turn on notifications"}
        </button>
      </div>
      <button onClick={dismiss} data-testid="push-prompt-dismiss" title="Not now"
        className="absolute top-4 right-4 p-1.5 rounded-full text-[#615A50] hover:text-[#C46B4E] hover:bg-white/60 transition-colors">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
